var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupervisorImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 63,
    viewBox: "0 0 55 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001848",
    filter: "url(#filter0_d_24_7923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.218 24.4463C17.5111 23.1262 20.5715 22.2911 22.3172 22.2911C22.3172 26.2028 25.4369 42.4799 25.4369 42.4799L26.5468 27.3019H28.7613L29.9089 42.4584C29.9089 42.4584 32.9316 26.359 32.9316 22.2695C34.6881 22.3126 37.7808 23.1424 39.0577 24.4786C42.3714 27.9 43.1257 37.6307 43.2496 43.105C43.3735 48.5792 13.2496 48.7502 11.9992 43.105C10.7487 37.4597 12.8882 27.8569 16.218 24.4463ZM16.3096 31.7901H21.6976V30.1737H16.3096V31.7901Z",
    fill: "#2B9FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5494 21.3204C23.4491 21.3204 20.712 18.788 19.8769 15.6306C18.4383 10.1887 18.7508 7.5486 18.9232 6.58954C19.6075 2.85564 23.4491 0 27.5494 0C31.6497 0 35.4967 2.85564 36.1702 6.58954C36.3534 7.54321 36.6659 10.1887 35.2273 15.6252C34.3922 18.788 31.6551 21.3204 27.5494 21.3204Z",
    fill: "#2B9FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.7599 25.986L26.5724 25.9914L25.5863 23.125H29.9668L28.7599 25.986Z",
    fill: "#2B9FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_7923",
    x: 0.388672,
    y: 0,
    width: 54.1113,
    height: 69.7754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.623529 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_7923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_7923",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisorImg);
export default __webpack_public_path__ + "static/media/supervisorImg.61741c3e38877de9f544f19737f09441.svg";
export { ForwardRef as ReactComponent };